// 3rd party imports
import * as React from 'react';

// bernie
import { DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

export interface PzInfoDialogProps {
  dialogId: string;
  l10n?: ILocalization;
  routeStore: RouteStore;
  programTitle: string;
  commissionPercentage: number;
  cookieDuration: number;
}

export const PzInfoDialog: React.FunctionComponent<PzInfoDialogProps> = ({
  dialogId,
  l10n,
  routeStore,
  programTitle,
  commissionPercentage,
  cookieDuration,
}) => {
  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const dialogContent = (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message="pz.signup.dialog.commission_rules" data={[programTitle]} />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkParagraph size={1}>
            <LocalizedText
              message="pz.signup.dialog.commission.we_will_pay_you_through_partnerize"
              data={[commissionPercentage]}
            />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText
              message="pz.signup.dialog.commission.the_guest_must_book_within_x_days"
              data={[programTitle, cookieDuration]}
            />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.dialog.commission.rental_amount" />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message="pz.signup.dialog.commission.payout_is_subject_to_terms" />
          </UitkParagraph>
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzInfo" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('common.dialog.close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
};
